/* eslint-disable no-undef */
import React from 'react';
import Link from 'next/link';
import ModalVideo from 'react-modal-video';
import { connect } from 'react-redux';
import flagContainer from '../../../flagContainer';

import styles from './footer.module.scss';
import SubscribeToMailList from '../SubscribeToMailList';

import config from '../../../config';

class HomePageFooter extends React.Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            submitting: false,
        };

        this.openModal = this.openModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }


    onKeyPress(event) {
        if (event.key === 'Enter' && event.target.type !== 'submit' && event.target.type !== 'button') {
            event.preventDefault();
        }
    }

    async handleSubmit(formValues) {
        const { apiHost } = config;
        this.setState({ submitting: true });
        fetch(`${apiHost}/v1/mailinglist/global`, {
            method: 'post',
            body: JSON.stringify(formValues),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                if (data.error) {
                    throw Error;
                }
                analytics.identify({
                    email: formValues.email,

                });
                this.setState({ submitting: false });
                this.props.showSuccess('Thank you for subscribing to UTR!');
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
                console.log('error', error);
                throw Error;
            });
    }

    openModal(video) {
        this.setState({ isOpen: video });
    }

    render() {
        return (
            <div className={`${styles.footer} ${this.props.className || ''}`}>
                <div className="container">
                    <div className={`row h100 ${styles.row}`}>
                        <div className={`offset-md-2 col-12 col-md-2 order-md-3 ${styles.footerLinks}`}>
                            <div>
                                <div className={styles.footerLinkHeader}>
                                    Players
                                </div>
                                <ul>
                                    <li>
                                        <Link
                                            href="/for-players"
                                        >
                                            <a className="text-gray">Features</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/how-utr-works"
                                        >
                                            <a className="text-gray">How UTR Works</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/power-players"
                                        >
                                            <a className="text-gray">Power Players</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/flex-leagues"
                                        >
                                            <a className="text-gray">Flex Leagues</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/matchplay"
                                        >
                                            <a className="text-gray">MatchPlay</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/ita-tour"
                                        >
                                            <a className="text-gray">ITA Tour</a>
                                        </Link>
                                    </li>
                                    {!flagContainer.redirectPtsToHome.isEnabled() && (
                                        <li>
                                            <Link
                                                href="/ptt"
                                            >
                                                <a className="text-gray">Pro Tennis</a>
                                            </Link>
                                        </li>
                                    )}
                                    <li>
                                        <Link
                                            href="/team-tennis"
                                        >
                                            <a className="text-gray">Team Tennis</a>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={`col-12 col-md-2 order-md-4 ${styles.footerLinks}`}>
                            <div>
                                <div className={styles.footerLinkHeader}>
                                    Organizers
                                </div>
                                <ul>
                                    <li>
                                        <Link
                                            href="/for-organizations"
                                        >
                                            <a className="text-gray">Clubs/Academies</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/college"
                                        >
                                            <a className="text-gray">College</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/high-school"
                                        >
                                            <a className="text-gray">High School</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/get-in-touch"
                                        >
                                            <a className="text-gray">Get in Touch</a>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={`col-12 col-md-2 order-md-5 ${styles.footerLinks}`}>
                            <div>
                                <div className={styles.footerLinkHeader}>
                                    Company
                                </div>
                                <ul>
                                    <li>
                                        <Link
                                            href="/about"
                                        >
                                            <a className="text-gray">About us</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/press"
                                        >
                                            <a className="text-gray">Press</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            href="/brandkit"
                                        >
                                            <a className="text-gray">Brand Kit</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <a href="https://apply.workable.com/universal-tennis" target="_blank" rel="noopener noreferrer" className="text-gray">Careers</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={`col-12 col-md-2 order-md-6 ${styles.footerLinks}`}>
                            <div>
                                <div className={styles.footerLinkHeader}>
                                    Other
                                </div>
                                <ul>
                                    <li>
                                        <a href="https://blog.universaltennis.com" target="_blank" rel="noopener noreferrer" className="text-gray">Discover</a>
                                    </li>
                                    <li>
                                        <a href={`https://shop.${config.siteBaseUrl}`} target="_blank" rel="noopener noreferrer" className="text-gray">Shop</a>
                                    </li>
                                    <li>
                                        <Link
                                            href="/ut-school"
                                        >
                                            <a className="text-gray">Universal Tennis School</a>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={`col-12 col-md-2 order-md-7 ${styles.footerLinks}`}>
                            <div>
                                <div className={styles.footerLinkHeader}>
                                    Support
                                </div>
                                <ul>
                                    <li>
                                        <a href={`https://support.${config.siteBaseUrl}/en/support/home`} target="_blank" rel="noopener noreferrer" className="text-gray">Help Center</a>
                                    </li>
                                    <li>
                                        <a href={`https://support.${config.siteBaseUrl}/en/support/home`} target="_blank" rel="noopener noreferrer" className="text-gray">Submit a Question</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div className={`col-12 col-md-10 order-md-2`}>
                            <SubscribeToMailList
                                label={'Be the first to know about new product launches, UTR Events and news!'}
                                field={'email'}
                                id={'email'}
                                handleSubmit={this.handleSubmit}
                                buttonLabel={'Subscribe'}
                                placeHolder={'YOUR EMAIL...'}
                                buttonStyle={`btn btn-primary btn-sm`}
                                submitting={this.state.submitting}
                            />
                        </div>
                        <div className={`col-12 col-md-2 order-md-1 ${styles.footerLogoWrapper}`}>
                            <img src="/img/utr-oracle-logo-header--dark.svg" />
                        </div>

                    </div>

                </div>
                <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video1'} videoId="u-uG5M3bULk" autoplay={true} onClose={() => this.setState({ isOpen: false })} />
                <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video2'} videoId="maJS-0kOwSo" autoplay={true} onClose={() => this.setState({ isOpen: false })} />
            </div>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        showSuccess: (msg) => dispatch({ type: 'SHOW_ERROR_POPUP', message: msg, custom: true, cta: 'OK' }),
    };
}

export default connect(null, mapDispatchToProps)(HomePageFooter);
